<script setup>
import zhCn from "element-plus/es/locale/lang/zh-cn";
provide('newTab', false);
let initThirdPart;
initThirdPart = () => {
  GAIDInit();
  AnalyticHub.getInstance.initAnalytic();
  User.getInstance.initGoogleSDK();
  window.removeEventListener('touchstart', initThirdPart)
  window.removeEventListener('click', initThirdPart)
  document.removeEventListener('scroll', initThirdPart)
}
onMounted(() => {
  Config.getInstance.loadConfig();
  AnalyticHub.getInstance.logApp();
  useStickySearchData().fetchTop8Trending()
  window.addEventListener('touchstart', initThirdPart)
  window.addEventListener('click', initThirdPart)
  document.addEventListener('scroll', initThirdPart)
})
await useStickySearchData().fetchCategoryList()

function GAIDInit () {
  const scriptDOM = document.createElement('script');
  scriptDOM.type = 'text/javascript';
  scriptDOM.src = `https://www.googletagmanager.com/gtag/js?id=${ENV.currentConfig.gaid}`;
  scriptDOM.async = true;
  document.head.appendChild(scriptDOM);
  window.dataLayer = window.dataLayer || [];
  function gtag () { 
    window.dataLayer.push(arguments); 
  }
  gtag('js', new Date());
  gtag('config', ENV.currentConfig.gaid);
}

</script>

<template>
  <div>
    <NuxtRouteAnnouncer />
  </div>

  <ElConfigProvider :locale="zhCn">
    <NuxtLayout id="app">
      <NuxtPage :page-key="route => route.fullPath" />
    </NuxtLayout>
  </ElConfigProvider>

</template>
<style lang="scss" scoped>
.custom-loading-text {
  color: red;
  font-size: 18px;
  text-align: center;
  margin-top: 500px;
  z-index: 99999999;
  position: absolute;
}
</style>
